export const STATUS_LABEL_CLASS = {
  1: {
    label: "Chờ HTKD duyệt",
    class: "badge-secondary"
  },
  2: {
    label: "Chờ duyệt",
    class: "badge-info"
  },
  3: {
    label: "Đang xử lý",
    class: "badge-warning"
  },
  4: {
    label: "Đang xử lý",
    class: "badge-primary"
  },
  5: {
    label: "Đang xử lý",
    class: "badge-danger"
  },
  6: {
    label: "Giám đốc phê duyệt",
    class: "badge-success"
  },
  7: {
    label: "Hoàn thành",
    class: "badge-success"
  },
  8: {
    label: "Chờ cập nhật BBTL",
    class: "badge-warning"
  },
  10: {
    label: "Đã hủy",
    class: "badge-danger"
  }
};